import { useState } from 'react'
import { SECONDARY_VIEW_KEYS } from '@/config/navigation/secondaryNav'

/** @param {ReturnType<typeof import('@/features/chat/chatPersist').loadChatPersist>} persisted */
export function useChatUiSlices(persisted) {
  const [homeView, setHomeView] = useState(persisted?.homeView ?? SECONDARY_VIEW_KEYS.HOME_MAIN)
  const [selectedThreadId, setSelectedThreadId] = useState(persisted?.selectedThreadId ?? null)
  const [activeQueryVersionByExchangeId, setActiveQueryVersionByExchangeId] = useState(
    persisted?.activeQueryVersionByExchangeId ?? {},
  )
  const [activeAnswerVersionByExchangeId, setActiveAnswerVersionByExchangeId] = useState(
    persisted?.activeAnswerVersionByExchangeId ?? {},
  )
  const [mainAskBarPrefill, setMainAskBarPrefill] = useState(null)

  return {
    homeView,
    setHomeView,
    selectedThreadId,
    setSelectedThreadId,
    activeQueryVersionByExchangeId,
    setActiveQueryVersionByExchangeId,
    activeAnswerVersionByExchangeId,
    setActiveAnswerVersionByExchangeId,
    mainAskBarPrefill,
    setMainAskBarPrefill,
  }
}
